import React, { useState } from 'react';
import { FormGroup, ControlLabel, Tab, Tabs } from 'react-bootstrap';

const TabbedInput = ({ input, options, name, id, label, onSelect }) => {
  //   const [selectedTab, setSelectedTab] = useState(options[0].value);

  const handleTabSelect = (tabValue) => {
    const selectedOption = options.find((option) => option.value === tabValue);

    const selectedObject = {
      label: selectedOption.label,
      value: selectedOption.value,
    };

    input.onChange(selectedObject);
    onSelect(selectedObject); // Assuming onSelect is a callback to handle tab selection
  };
  return (
    <div> 
      <FormGroup >
        <ControlLabel>{label}</ControlLabel>
        <div className='tabs-box'>
          <Tabs defaultActiveKey={''} onSelect={(tabValue) => handleTabSelect(tabValue)}
          className="custom-tabs"
          >
            {options.map((option) => (
              <Tab key={option.value} eventKey={option.value} title={option.label}
               />
            ))}
          </Tabs>
        </div>
      </FormGroup>
      {/* Additional content for the selected tab */}
    </div>
  );
};

export default TabbedInput;



// WEBPACK FOOTER //
// src/routes/tours/components/TabbedInput.js